import { Select, Button } from 'antd';

const { Option, OptGroup } = Select;

interface OptionItem {
	value: string;
	label: string;
	/** Matched by search instead of the label when set. */
	searchText?: string;
}

interface OptionGroup {
	label: string;
	options: OptionItem[];
}

interface Props {
	value: string[];
	onChange: (value: string[]) => void;
	onApply: () => void;
	optionGroups?: OptionGroup[];
	options?: OptionItem[];
	placeholder?: string;
	mode?: 'multiple' | 'tags';
	/** Compact mode for tablet/horizontal layouts */
	compact?: boolean;
	showApplyButton?: boolean;
}

export const SelectFilter = ({
	value,
	onChange,
	onApply,
	optionGroups,
	options,
	placeholder = 'Select...',
	mode = 'multiple',
	compact = false,
	showApplyButton = true,
}: Props) => {
	return (
		<div>
			<Select
				mode={mode}
				placeholder={placeholder}
				value={value}
				onChange={(vals) => {
					onChange(vals);
				}}
				style={{
					width: compact ? 180 : '100%',
					marginBottom: compact ? 0 : 8,
				}}
				maxTagCount={compact ? undefined : 'responsive'}
				size={compact ? 'small' : 'middle'}
				showSearch
				popupMatchSelectWidth={false}
				className={compact ? 'select-filter-compact' : ''}
				optionFilterProp="label"
				filterOption={(input, option) => {
					const raw =
						(option as any)?.searchText ??
						(option as any)?.label ??
						(option as any)?.value ??
						((option as any)?.props?.children ?? '');
					const searchable =
						typeof raw === 'string' ? raw : (Array.isArray(raw) ? raw.join('') : String(raw));
					return searchable.toLowerCase().includes((input || '').toLowerCase());
				}}
			>
				{optionGroups?.map((group) => (
					<OptGroup key={group.label} label={group.label}>
						{group.options.map((opt) => (
							<Option key={opt.value} value={opt.value} label={opt.label} searchText={opt.searchText}>
								{opt.label}
							</Option>
						))}
					</OptGroup>
				))}
				{!optionGroups &&
					options?.map((opt) => (
						<Option key={opt.value} value={opt.value} label={opt.label}>
							{opt.label}
						</Option>
					))}
			</Select>
			{!compact && showApplyButton && (
				<Button
					type="primary"
					block
					onClick={onApply}
					disabled={value.length === 0}
				>
					Apply
				</Button>
			)}
		</div>
	);
};
